import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../redux/hooks";

import { UsersListInterface } from "../../../../redux/interfaces/admin.interface";

import moment from "moment";
import "moment/locale/ro";

import Dropdown, { DropdownValue } from "../../../../components/misc/Dropdown";
import {
  getCurrentYearOrMonth,
  getDaysInMonth,
} from "../../../../utils/dateAndTime";
import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";

const lastThreeYears = [
  getCurrentYearOrMonth("year"),
  getCurrentYearOrMonth("year") - 1,
  getCurrentYearOrMonth("year") - 2,
];

const usersRole = [
  { id: "putAway", label: "Putaway" },
  { id: "rearanjare", label: "Rearanjare" },
  { id: "umplere", label: "Umplere" },
  { id: "comenziColectate", label: "Comenzi colectate" },
  { id: "comenziVerificate", label: "Comenzi verificate" },
  { id: "produseReceptionate", label: "Produse receptionate" },
  { id: "produseSolutionate", label: "Produse solutionate" },
  { id: "receptiiDeschise", label: "Receptii deschise" },
];

const monthsDataDropdownValue = moment
  .monthsShort()
  .map((month: string, index: number) => {
    return {
      id: index + 1,
      label: month,
    };
  });

const yearsDataDropdownValue = lastThreeYears.map((year: number) => {
  return {
    id: year,
    label: year,
  };
});

const usersRoleDropdownValue = usersRole.map((role) => {
  return {
    id: role.id,
    label: role.label,
  };
});

const allOption = {
  id: 0,
  label: "Toate",
};

function DropdownsPageHeader() {
  const { handleTableSearch } = useTableCtx() || {};

  const [selectedDay, setSelectedDay] = useState<DropdownValue>(allOption);
  const [selectedMonth, setSelectedMonth] = useState<DropdownValue>(
    monthsDataDropdownValue[getCurrentYearOrMonth("month", 1)],
  );
  const [selectedYear, setSelectedYear] = useState<DropdownValue>(
    yearsDataDropdownValue[0],
  );
  const [selectedUsers, setSelectedUsers] = useState<DropdownValue[]>([]);
  const [selectedRoles, setselectedRoles] = useState<DropdownValue[]>([]);

  const daysOfMonth = getDaysInMonth(selectedMonth.id, selectedYear.id);
  const daysDropdownValue = daysOfMonth.map((day) => {
    return {
      id: parseInt(day),
      label: day,
    };
  });

  const daysDropdownValueWithAll = [
    { id: 0, label: "Toate" },
    ...daysDropdownValue,
  ];

  const {
    admin: {
      users: {
        data: { data: users },
      },
    },
  } = useAppSelector((state) => ({
    admin: state.admin,
  }));

  useEffect(() => {
    handleTableSearch && handleTableSearch("selectedDay", selectedDay?.id);
  }, [handleTableSearch, selectedDay]);

  useEffect(() => {
    handleTableSearch && handleTableSearch("selectedMonth", selectedMonth?.id);
  }, [handleTableSearch, selectedMonth]);

  useEffect(() => {
    handleTableSearch && handleTableSearch("selectedYear", selectedYear?.id);
  }, [handleTableSearch, selectedYear]);

  useEffect(() => {
    handleTableSearch &&
      handleTableSearch("selectedUsers", JSON.stringify(selectedUsers));
  }, [handleTableSearch, selectedUsers]);

  useEffect(() => {
    handleTableSearch &&
      handleTableSearch("selectedRoles", JSON.stringify(selectedRoles));
  }, [handleTableSearch, selectedRoles]);

  const usersDropdownValue = users.map((user: UsersListInterface) => {
    return {
      id: user.userId,
      label: user.userName,
    };
  });

  return (
    <div className="d-flex justify-content-center">
      <Dropdown
        className="mb-4 me-2"
        title="Selecteaza ziua"
        data={daysDropdownValueWithAll}
        singleValue={selectedDay}
        setSingleValue={(value) => value && setSelectedDay(value)}
      />

      <Dropdown
        className="mb-4 me-2"
        title="Selecteaza luna"
        data={monthsDataDropdownValue}
        singleValue={selectedMonth}
        setSingleValue={(value) => value && setSelectedMonth(value)}
      />

      <Dropdown
        className="mb-4 me-2"
        title="Selecteaza anul"
        data={yearsDataDropdownValue}
        singleValue={selectedYear ?? yearsDataDropdownValue[0]}
        setSingleValue={(value) => value && setSelectedYear(value)}
      />

      <Dropdown
        className="mb-4 me-2"
        title="Utilizatori"
        data={usersDropdownValue}
        multipleValues={selectedUsers}
        setMultipleValues={setSelectedUsers}
      />

      <Dropdown
        className="mb-4 me-2"
        title="Roluri"
        data={usersRoleDropdownValue}
        multipleValues={selectedRoles}
        setMultipleValues={setselectedRoles}
      />

      {/* <Dropdown
        className="mb-4 me-2"
        title="Categorie utilizator"
        data={monthsDataDropdownValue}
        singleValue={selectedMonth}
        setSingleValue={setSelectedMonth}
      /> */}
    </div>
  );
}

export default DropdownsPageHeader;
